module.exports = __webpack_public_path__ + "img/85800.bb5c776f.jpg";